type ReturnLocation = Pick<URL, 'pathname' | 'search' | 'hash'>;

export function currentReturnTo(location: ReturnLocation): string {
  const pathname = location.pathname.startsWith('/') ? location.pathname : '/';
  return `${pathname}${location.search || ''}${location.hash || ''}`;
}

export function buildAuthCenterLogin(currentUrl: URL): string {
  const callback = new URL('/sso-callback', currentUrl.origin);
  callback.searchParams.set('return_to', currentReturnTo(currentUrl));

  const login = new URL('/login', 'https://accounts.aryuki.com');
  login.searchParams.set('client_id', 'class-schedule');
  login.searchParams.set('redirect', callback.toString());
  return login.toString();
}

export function safeAuthReturnTo(value: string | null | undefined, origin: string): string {
  if (!value) return '/';
  try {
    const base = new URL(origin).origin;
    const trimmed = value.trim();
    if (!trimmed.startsWith('/') && !/^https:\/\//i.test(trimmed)) return '/';
    const target = new URL(trimmed, base);
    if (target.origin !== base || target.pathname === '/sso-callback' || target.searchParams.has('token')) return '/';
    return `${target.pathname}${target.search}${target.hash}` || '/';
  } catch {
    return '/';
  }
}
